import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  InputAdornment,
  tableCellClasses,
  Paper,
  IconButton,
  Dialog,
} from "@mui/material";
import ClientServices from "services/Client";
import VehicleBookingServices from "services/VehicleBooking";
import InputField from "components/Input";
import DatePicker from "components/DatePicker";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { SearchIcon, FontFamily } from "assets";
import SelectField from "components/Select";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { Delete } from "@mui/icons-material";
import { CancelOutlined } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import SystemServices from "services/System";
import { createRoot } from "react-dom/client";
import SpecialDiscountInvoice from "components/erp_invoices/special_discount_invoice";

const Row = styled(TableRow)({ border: 0 });
const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
  },
});

// const useStyles = {
//   tableHeader: {
//     backgroundColor: '#f5f5f5',
//     fontWeight: 'bold',
//   },
//   tableCell: {
//     textAlign: 'center',
//   },
//   notesTextArea: {
//     width: '100%',
//     marginTop: '20px',
//   },
// };

const SpecialDiscount = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [selectedVin, setSelectedVin] = useState("");
  const [rows, setRows] = useState([]);
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    notes: "",
    date: "",
    vehicles: [],
  });
  const {
    register,
    formState: { errors },
    getValues: getValues1,
  } = useForm();
  const [isSearching, setIsSearching] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState(
    location.state?.selectedRows || []
  );
  const [filters, setFilters] = useState({});
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBookingCustomer, setSelectedBookingCustomer] = useState(null);
  const [bookingCustomers, setBookingCustomers] = useState([]);
  const [referenceNo, setReferenceNo] = useState("");

  // const generateReferenceNo = () => {
  //     // const timestamp = Date.now(); // milliseconds since epoch
  //     const randomStr = Math.random().toString(5).substring(2, 6).toUpperCase(); // 4 char random
  //     return `REF-${randomStr}`;
  // };

  const generateReferenceNo = () => {
    const now = new Date();
    const ymd = now.toISOString().slice(2, 10).replace(/-/g, "");
    // Use a static variable to keep track of used reference numbers in memory only
    if (!window._usedReferenceNos) {
      window._usedReferenceNos = new Set();
    }
    let refNo;
    let tries = 0;
    do {
      const bytes = new Uint8Array(4);
      if (typeof crypto !== "undefined" && crypto.getRandomValues) {
        crypto.getRandomValues(bytes);
      } else {
        for (let i = 0; i < bytes.length; i++)
          bytes[i] = Math.floor(Math.random() * 256);
      }
      let rnd = "";
      for (const b of bytes) rnd += (b % 10).toString();
      refNo = `REF-${ymd}-${rnd}`;
      tries++;
      if (tries > 1000)
        throw new Error("Unable to generate unique reference number");
    } while (window._usedReferenceNos.has(refNo));
    window._usedReferenceNos.add(refNo);
    return refNo;
  };

  // const getAllSLPVehicles = async (page, limit, filter) => {
  //     try {
  //         const Page = page ? page : currentPage;
  //         const Limit = limit ? limit : pageLimit;
  //         const Filter = { ...filters, ...filter };

  //         let params = {
  //             page: Page,
  //             limit: Limit,
  //             ...Filter,
  //         };

  //         const { data } = await ClientServices.getSLPVehicles(params);

  //         if (filter?.search) {
  //             const matchedVehicle = data.vehicles.find(vehicle => vehicle.vin === filter.search);

  //             if (matchedVehicle) {
  //                 const alreadyExists = rows.find(row => row.vin === matchedVehicle.vin);

  //                 if (!alreadyExists) {
  //                     const isFirstRow = rows.length === 0;
  //                     // const isSameBuyer = !isFirstRow && rows[0].buyer_id === matchedVehicle.buyer_id;

  //                     if (isFirstRow) {
  //                         const newRow = {
  //                             id: matchedVehicle.id,
  //                             customer: matchedVehicle.customer?.name,
  //                             buyer_id: matchedVehicle.buyer_id,
  //                             buyer_name: matchedVehicle.buyer.name,
  //                             vin: matchedVehicle.vin,
  //                             lot: matchedVehicle.lot_number,
  //                             make: matchedVehicle.veh_make?.name || '',
  //                             model: matchedVehicle.veh_model?.name || '',
  //                             discount: 0,
  //                         };
  //                         setRows([...rows, newRow]);
  //                     } else {
  //                         ErrorToaster("Vehicles with a different buyer ID cannot be added.");
  //                     }
  //                 }
  //                 else {
  //                     ErrorToaster("This VIN is already added.");
  //                 }
  //             } else {
  //                 ErrorToaster("VIN not found.");
  //             }
  //         } else {
  //             setVehicles(data.vehicles);
  //         }

  //         setCurrentPage(Page);
  //         setPageLimit(Limit);
  //         setFilters(Filter);
  //     } catch (error) {
  //         console.log(error);
  //     }
  // };

  const getAllSLPVehicles = async (page, limit, filter) => {
    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = { ...filters, ...filter };

      let params = {
        page: Page,
        limit: Limit,
        ...Filter,
      };

      const { data } = await ClientServices.getSLPVehicles(params);

      if (filter?.search) {
        const matchedVehicle = data.vehicles.find(
          (vehicle) => vehicle.vin === filter.search
        );

        if (matchedVehicle) {
          const alreadyExists = rows.find(
            (row) => row.vin === matchedVehicle.vin
          );

          if (!alreadyExists) {
            const isFirstRow = rows.length === 0;

            // Allow vehicles with different buyer IDs to be added
            const newRow = {
              id: matchedVehicle.id,
              customer: matchedVehicle.customer?.name,
              buyer_id: matchedVehicle.buyer_id,
              buyer_name: matchedVehicle.buyer.name,
              vin: matchedVehicle.vin,
              lot: matchedVehicle.lot_number,
              make: matchedVehicle.veh_make?.name || "",
              model: matchedVehicle.veh_model?.name || "",
              discount: 0,
            };

            setRows([...rows, newRow]);
          } else {
            ErrorToaster("This VIN is already added.");
          }
        } else {
          ErrorToaster("VIN not found.");
        }
      } else {
        setVehicles(data.vehicles);
      }

      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllSLPVehicles();
    getBookingCustomers();
  }, []);

  useEffect(() => {
    const refNo = generateReferenceNo();
    setReferenceNo(refNo);
  }, []);

  const handleEditClick = (row) => {
    setSelectedRows(row); // Store the row data
    setOpenEditModal(true); // Open the modal for editing
    setNotes((prev) => ({ ...prev, [row.id]: row.notes || "" })); // Pre-fill the modal with the current note
  };

  const handleDiscountSChange = (id, value) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, discount: value } : row
    );
    setRows(updatedRows);
  };

  const handleCourierChargesChange = (id, value) => {
    const updatedRows = rows.map((row) =>
      row.id === id
        ? { ...row, courierCharges: value, total: row.lps + row.stgS + value }
        : row
    );
    setRows(updatedRows);
  };

  const handleNotesChange = (e) => {
    const { value } = e.target;
    setNotes((prev) => ({
      ...prev,
      [selectedRows.id]: value, // Update the note for the selected row
    }));
  };

  const handleSaveNotes = () => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === selectedRows.id
          ? { ...row, notes: notes[selectedRows.id] } // Update the note for the specific row
          : row
      )
    );
    setOpenEditModal(false);
  };

  const handleDelete = (vin) => {
    const updatedRows = rows.filter((row) => row.vin !== vin);
    setRows(updatedRows);
  };

  const totalDiscount = rows.reduce(
    (acc, row) => acc + (parseFloat(row.discount) || 0),
    0
  );
  const handleSubmit = async () => {
    const vehiclesData = rows.map((row) => ({
      booking_id: row.id,
      discount: row.discount,
      customer_name: row.customer,
    }));

    const finalData = {
      date: formData.date || selectedDate || new Date(),
      credit_customer: selectedBookingCustomer?.id,
      reference_no: referenceNo,
      totalDiscount: totalDiscount,
      notes: formData.notes,
      vehicles: vehiclesData,
    };

    try {
      setLoading(true);
      // Call the API to submit the data
      const response = await ClientServices.specialDiscount(finalData);

      if (response.status) {
        const reference_no = finalData?.reference_no;
        const special_dis_id = response?.data?.special_dis_id;

        let params = { special_dis_id: special_dis_id };
        const { data } = await ClientServices.specialDiscountDetails(params);

        if (!data) {
          console.log("No record found to upload");
          return;
        }

        const uploadFiles = [];

        const file = await new Promise((resolve, reject) => {
          try {
            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.top = "-99999px";
            container.style.left = "-99999px";
            container.style.width = "1200px";
            document.body.appendChild(container);

            const root = createRoot(container);

            const handleDone = (pdfBlob) => {
              setTimeout(() => {
                try {
                  root.unmount();
                  container.remove();
                } catch (err) {
                  console.error("❌ Cleanup Error", err);
                }
                resolve(pdfBlob);
              }, 200);
            };

            root.render(
              <SpecialDiscountInvoice
                originalData={data?.detail?.rows}
                onDone={handleDone}
              />
            );
          } catch (err) {
            console.error("❌ PDF Generation Error", err);
            reject(err);
          }
        });

        const pdfFile =
          file instanceof Blob
            ? new File(
                [file],
                `specialDiscount-${data?.detail?.rows?.[0]?.reference_no}.pdf`,
                {
                  type: "application/pdf",
                }
              )
            : null;

        uploadFiles.push({
          reference_no: reference_no,
          file: pdfFile,
        });

        const formData = new FormData();
        formData.append("invoice_type", "specialDiscount");

        uploadFiles.forEach((file, index) => {
          formData.append(
            `special_discount[${index}][reference_no]`,
            reference_no
          );
          formData.append(`special_discount[${index}][file]`, file.file);
        });

        await SystemServices.uploadERPInvoices(formData);
        setRows([]);
        setNotes("");
        setFormData({
          date: "",
          vehicles: [],
        });
        setLoading(false);
        SuccessToaster("Submitted successfully.");
        navigate("/special-discount-list");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  const getBookingCustomers = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await VehicleBookingServices.getBookingCustomers(params);
      setBookingCustomers(
        data?.filters.map((item) => {
          return { id: item?.customer_id, name: item?.customer_name };
        })
      );
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const vinOptions = vehicles.map((item) => ({
    id: item?.vin,
    name: item?.vin,
  }));

  const handleFilter = async (data) => {
    if (!data) {
      return;
    }

    if (isSearching) return;

    setIsSearching(true);
    try {
      await getAllSLPVehicles(1, "", data);
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
    }
  };

  return (
    <Fragment>
      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "30%",
            height: "auto",
            borderRadius: 2,
            py: { xs: 2, md: 4 },
            px: { xs: 3, md: 6 },
          },
        }}
      >
        <IconButton
          onClick={() => setOpenEditModal(false)}
          sx={{ position: "absolute", right: 13, top: 13 }}
        >
          <CancelOutlined />
        </IconButton>
        <Box component={"form"}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
            Notes
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={1}
            value={notes[selectedRows?.id] ?? ""}
            onChange={handleNotesChange}
            placeholder="Enter notes"
          />

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <PrimaryButton title="Submit" onClick={handleSaveNotes} />
          </Box>
        </Box>
      </Dialog>

      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Special Discount
            </Typography>
          </Box>
        </Grid>
        {/* Filters */}
        <Grid item md={11}>
          <Box
            sx={{
              m: "10px 0 10px 0",
              // p: '20px',
              // bgcolor: Colors.feta,
              // border: `1px solid ${Colors.iron}`,
              // borderRadius: '9px',
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems={"center"}
              component={"form"}
            >
              <Grid item xs={12} sm={2.5} sx={{ marginTop: "5px" }}>
                <InputField
                  size={"small"}
                  inputStyle={{ backgroundColor: "#f5f5f5" }}
                  label={"Search"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  placeholder={"Search"}
                  register={register("search")}
                />
              </Grid>
              <Grid item xs={12} sm={2.5}>
                <DatePicker
                  size={"small"}
                  label={"Select Date"}
                  value={
                    selectedDate ? moment(selectedDate).toDate() : new Date()
                  }
                  onChange={(date) =>
                    setSelectedDate(moment(date).format("YYYY-MM-DD"))
                  }
                />
              </Grid>

              <Grid item xs={12} sm={2.5} sx={{ marginTop: "7px" }}>
                <SelectField
                  size={"small"}
                  onSearch={(v) => getBookingCustomers(v)}
                  label={"Credit To Customer"}
                  options={bookingCustomers}
                  selected={selectedBookingCustomer}
                  onSelect={(value) => {
                    setSelectedBookingCustomer(value);
                    handleFilter({ customer_id: value?.id });
                  }}
                  register={register("bookingCustomer")}
                />
              </Grid>
              <Grid item xs={12} sm={2.5} sx={{ marginTop: "5px" }}>
                <InputField
                  size={"small"}
                  // inputStyle={{ backgroundColor: "#f5f5f5" }}
                  label={"Ref.No"}
                  // InputProps={{
                  //     startAdornment: (
                  //         <InputAdornment position="start">
                  //             <SearchIcon />
                  //         </InputAdornment>
                  //     ),
                  // }}
                  value={referenceNo}
                  placeholder={"Ref.No"}
                  register={register("refNo")}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <Box
                  sx={{
                    mt: "16px",
                  }}
                >
                  <PrimaryButton
                    onClick={() => {
                      const searchVal = getValues1("search");
                      if (searchVal) {
                        handleFilter({ search: searchVal });
                      }
                    }}
                    title="Search"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                borderRadius: 2,
                maxHeight: "calc(100vh - 330px)",
                mt: 2,
              }}
              className="table-box"
            >
              <Table stickyHeader sx={{ minWidth: 500 }}>
                <TableHead>
                  <TableRow>
                    <Cell>Customer Name</Cell>
                    <Cell>VIN</Cell>
                    <Cell>LOT</Cell>
                    <Cell>Model/Make</Cell>
                    <Cell sx={{ width: "10%" }}>Discount$</Cell>
                    {/* <Cell>Notes</Cell> */}
                    <Cell>Action</Cell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.length > 0 ? (
                    <>
                      {rows.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            bgcolor:
                              rows.indexOf(row) % 2 !== 0
                                ? "#EFF8E7"
                                : "inherit",
                          }}
                        >
                          <Cell>{row.customer}</Cell>
                          <Cell>{row.vin}</Cell>
                          <Cell>{row.lot}</Cell>
                          <Cell>
                            {row?.model}
                            {"-"}
                            {row.make}
                          </Cell>
                          <Cell sx={{ width: "10%" }}>
                            <InputField
                              size="small"
                              type="number"
                              value={row.discount}
                              onInput={(e) =>
                                handleDiscountSChange(
                                  row.id,
                                  parseFloat(e.target.value)
                                )
                              }
                            />
                          </Cell>
                          {/* <Cell>
                                                        <Box
                                                            component={"div"}
                                                            onClick={() => handleEditClick(row)}
                                                        >
                                                            <EditIcon />
                                                        </Box>
                                                    </Cell> */}
                          <Cell>
                            <IconButton
                              onClick={() => handleDelete(row.vin)}
                              color="error"
                            >
                              <Delete />
                            </IconButton>
                          </Cell>
                        </TableRow>
                      ))}
                      {/* Total Row */}
                      <TableRow
                        sx={{
                          bgcolor: "#DFF0D8", // light green background for total
                          fontWeight: "bold",
                        }}
                      >
                        <Cell
                          colSpan={4}
                          sx={{ textAlign: "right", fontWeight: "bold" }}
                        >
                          Total Discount
                        </Cell>
                        <Cell sx={{ fontWeight: "bold", width: "10%" }}>
                          {totalDiscount.toFixed(2)}
                        </Cell>
                        <Cell colSpan={2} />
                      </TableRow>
                    </>
                  ) : (
                    <TableRow>
                      <Cell
                        colSpan={11}
                        sx={{
                          textAlign: "center",
                          fontWeight: "bold",
                          fontFamily: FontFamily.NunitoRegular,
                          fontSize: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          No Data Found
                        </Box>
                      </Cell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
        {/* Notes */}
        <Grid item md={11}>
          <Grid item md={4}>
            <InputField
              label={"Add Notes"}
              multiline
              // rows={3}
              placeholder={"Notes"}
              value={formData.notes}
              onInput={(e) =>
                setFormData((prev) => ({ ...prev, notes: e.target.value }))
              }
            />
          </Grid>
        </Grid>

        {/* Submit Button */}
        <Grid item md={11} justifyContent="end">
          <Box
            sx={{
              mt: "28px",
              mb: "28px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <PrimaryButton
              onClick={handleSubmit}
              title="Submit"
              loading={loading}
              disabled={!selectedBookingCustomer}
            />
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default SpecialDiscount;
